import { defineMessages } from 'react-intl';

export const InstallationTechnologyStepContent = defineMessages({
  title: {
    id: 'app.InstallationTechnologyStepContent.title',
    defaultMessage: 'Identifikované měřidlo',
  },
  strapiId: {
    id: 'app.common.strapiId',
    defaultMessage: 'StrapiId',
  },
  sn: {
    id: 'app.common.sn',
    defaultMessage: 'SN',
  },
});
